module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_27.1ede888f.pdf";